(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/content.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/content.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogContent = function (_svs$components$dialo) {
    _inherits(DialogContent, _svs$components$dialo);

    var _super = _createSuper(DialogContent);

    function DialogContent(options) {
      var _this;

      _classCallCheck(this, DialogContent);

      _this = _super.call(this);
      _this.log = new svs.core.log.Logger('DialogContent');
      _this.options = options;
      _this.hasScrollbar = false;
      _this.scrolledBottom = null;

      _this.render();

      return _this;
    }

    _createClass(DialogContent, [{
      key: "addMessageRow",
      value: function addMessageRow(message, i) {
        var messageRow = document.createElement('div');
        messageRow.className += "dialog-message-row dialog-message-".concat(message.type);

        if (message.align) {
          messageRow.className += " ".concat(message.align);
        }

        switch (message.type) {
          case svs.components.dialog.message.CHECKBOX:
            messageRow.innerHTML = svs.ui.form.partials.checkbox({
              value: message.value,
              label: message.text,
              checked: message.checked || false,
              class: 'js-dialog-item-checkbox',
              id: message.id ? message.id : i
            });
            break;

          default:
            messageRow.innerHTML = message.text;
            break;
        }

        return messageRow;
      }
    }, {
      key: "updateScrollPosition",
      value: function updateScrollPosition() {
        if (Math.ceil(this.el.scrollTop) >= this.el.scrollHeight - this.el.offsetHeight) {
          if (!this.scrolledBottom) {
            this.emit('contentBottom');
            this.scrolledBottom = true;
          }
        } else if (this.scrolledBottom === null || this.scrolledBottom) {
          this.emit('contentScrolling');
          this.scrolledBottom = false;
        }
      }
    }, {
      key: "addScrollListener",
      value: function addScrollListener() {
        var _this2 = this;

        this.el.onscroll = function () {
          _this2.updateScrollPosition();
        };
      }
    }, {
      key: "removeScrollListener",
      value: function removeScrollListener() {
        this.el.onscroll = null;
      }
    }, {
      key: "testScrollArea",
      value: function testScrollArea() {
        if (this.el.scrollHeight - this.el.offsetHeight) {
          if (!this.hasScrollbar) {
            this.addScrollListener();
            this.hasScrollbar = true;
          }
        } else if (this.hasScrollbar) {
          this.removeScrollListener();
          this.hasScrollbar = false;
        }

        this.updateScrollPosition();
      }
    }, {
      key: "scrollToEnd",
      value: function scrollToEnd() {
        var scrollToPosition = this.el.scrollHeight - this.el.offsetHeight;
        gsap.to(this.el, {
          duration: 0.3,
          scrollTop: scrollToPosition
        });
      }
    }, {
      key: "filterAcceptedMessages",
      value: function filterAcceptedMessages(m) {
        return m.text.length;
      }
    }, {
      key: "createButtonWrapper",
      value: function createButtonWrapper() {
        this.el = document.createElement('div');
        this.el.className += 'dialog-content js-dialog-content';
      }
    }, {
      key: "addIcon",
      value: function addIcon() {
        if (this.options.icon) {
          this._icon = new svs.components.dialog.Icon(this.options.icon);
          this.el.appendChild(this._icon.el);
        }
      }
    }, {
      key: "createTextWrapper",
      value: function createTextWrapper() {
        this._textEl = document.createElement('div');
        this._textEl.className += 'dialog-text';
        this.el.appendChild(this._textEl);
      }
    }, {
      key: "createTitle",
      value: function createTitle() {
        this._titleEl = document.createElement('div');
        this._titleEl.className += 'dialog-title';
        this._titleEl.innerText += this.options.title;

        this._textEl.appendChild(this._titleEl);
      }
    }, {
      key: "createMessageRows",
      value: function createMessageRows() {
        var _this3 = this;

        if (this.options.message) {
          var textRows = this.options.message.filter(this.filterAcceptedMessages);

          if (textRows) {
            this._messageEl = document.createElement('div');
            this._messageEl.className += 'dialog-message';

            this._textEl.appendChild(this._messageEl);

            this.el.className += ' dialog-content-scrollable';
            var rowAlignProp = false;
            textRows.forEach(function (message, i) {
              if (message.align) {
                rowAlignProp = true;
              }

              _this3._messageEl.appendChild(_this3.addMessageRow(message, i));
            }); 

            if (textRows.length > 1 && !rowAlignProp) {
              this.el.className += ' dialog-text-left';
            }
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        this.createButtonWrapper();
        this.addIcon();
        this.createTextWrapper();
        this.createTitle();
        this.createMessageRows();
      }
    }]);

    return DialogContent;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.Content = DialogContent;
})(svs, gsap);
 })(window);